export const EnumContentType = {
    json: 'application/json',
    formUrlencoded: 'application/x-www-form-urlencoded',
    formData: 'multipart/form-data'
}

export const EnumNetworkErrMap = {
    400: '请求出现语法错误~',
    401: '用户未授权~',
    403: '服务器拒绝访问~',
    404: '请求的资源不存在~',
    405: '请求方法未允许~',
    408: '网络请求超时~',
    500: '服务器内部错误~',
    501: '服务器未实现请求功能~',
    502: '错误网关~',
    503: '服务不可用~',
    504: '网关超时~',
    505: 'http版本不支持该请求~',
};

export const EnumAuthErrMap = {
    '702': '登录失效，需要重新登录', // token 失效
    '10032': '您太久没登录，请重新登录~', // token 过期
    '10033': '账户未绑定角色，请联系管理员绑定角色',
    '10034': '该用户未注册，请联系管理员注册用户',
    '10035': 'code 无法获取对应第三方平台用户',
    '10036': '该账户未关联员工，请联系管理员做关联',
    '10037': '账号已无效',
    '10038': '账号未找到'
};

export const EnumNetworkSetting = {
    // 超时时间
    timeout: 120000
}

export const EnumSystemSetting = {
    identityExpiredCode: 720
}

export const EnumDefaultResponseResult = {
    code: 741,
    message: "未知错误，请联系系统管理员"
}

export const EnumLocalStore = {
    jwtTokenName: 'adminJwtToken',
    authorizationHeaderName: 'token'
}

export const EnumBackEndApiPrefix = [
    'cotton',
    'source',
    'mars',
    'lilliput',
    'plat'
]

export const EnumDocRequest = {
    resource: 'swagger-resources',
    docApi: 'api-docs'
}

export const EnumPermission = {
    superAdministratorName: '超级管理员'
}
